export default __webpack_public_path__ + "static/media/Logo-5bits-Small.77552a54.svg";